import { useEffect, useState } from "react";
import { startCase } from "lodash";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import {
  formatDate,
  toFixedWithoutRounding,
  betCheckObj,
} from "../../Utils/Constant";
import ProfitLossCell from "../../Utils/ProfitLossCell";
import Pagination from "../../components/Pagination";

const styleHead = { padding: "8px" };
const styleBody = { padding: "8px 7px" };

export default function ProfitLossReportModal({
  isOpen,
  onClose,
  item,
  parentFilter,
}) {
  const [data, setData] = useState({ data: [], totalDocs: 0 });
  const [filter, setFilter] = useState({ page: 1, limit: 50 });

  const getData = async (activeFilter, activeItem) => {
    if (!activeItem || !parentFilter) return;
    const { status, data: response_users } = await apiGet(
      apiPath.getBets +
        "?fromPeriod=" +
        parentFilter.fromPeriod +
        "&toPeriod=" +
        parentFilter.toPeriod +
        "&eventType=" +
        activeItem?.eventType +
        "&eventId=" +
        activeItem?.eventId +
        "&betType=" +
        activeItem?.betFaireType +
        "&type=" +
        activeItem?.eventType +
        "&page=" +
        activeFilter.page +
        "&limit=" +
        activeFilter.limit,
    );
    if (status === 200 && response_users.success) {
      setData(response_users.results || { data: [], totalDocs: 0 });
    }
  };

  // fires on open (new item) and whenever page/limit change within the modal
  useEffect(() => {
    if (isOpen && item) {
      getData(filter, item);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, filter.limit, isOpen, item]);

  // reset to page 1 whenever a different market is opened
  useEffect(() => {
    if (isOpen && item) {
      setFilter((prev) => ({ ...prev, page: 1 }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.eventId, item?.betFaireType, item?.gameType, isOpen]);

  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const handleLimitChange = (e) => {
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  };

  // lock background page scroll while the modal is open
  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="pop_bg"
      style={{
        position: "fixed",
        inset: 0,
        height: "100%",
        width: "100%",
        display: "block",
        overflow: "hidden",
      }}
      onClick={() => onClose?.()}
    >
      <div
        className="pop_boxs pop_refer"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          backgroundColor: "#eee",
          width: "95%",
          maxHeight: "90vh",
          overflowY: "auto",
          WebkitOverflowScrolling: "touch",
          borderRadius: "5px",
          padding: "15px",
          transform: "translate(-50%,-50%)",
          boxShadow: "0 4px 5px #00000080",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="close-body">
          <a
            href="#"
            className="close_pop"
            onClick={(e) => {
              e.preventDefault();
              onClose();
            }}
          >
            close_pop
          </a>
        </div>

        <div className="table-responsive data-table">
          <div style={{ marginBottom: "10px" }} className="popup-heading">
            {startCase(item?.gameType)}
            <span className="spacer">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                fill="lightgray"
                width={16}
                height={16}
              >
                <path d="M10.354 8L5.177 2.823a.5.5 0 0 1 .707-.707l6 6a.5.5 0 0 1 0 .707l-6 6a.5.5 0 0 1-.707-.707L10.354 8z" />
              </svg>
            </span>
            {startCase(item?.matchName)}
          </div>

          <div id="report">
            <div className="diaplayflex divblock">
              <label className="itemsort">Last:</label>
              <select
                name="limit"
                id="limit"
                value={filter.limit}
                onChange={handleLimitChange}
              >
                <option value={10}>10 Txn</option>
                <option value={25}>25 Txn</option>
                <option value={50}>50 Txn</option>
                <option value={100}>100 Txn</option>
              </select>
              <div className="pnl-data">
                <span className="total-users">
                  Total Records: <strong>{data?.totalDocs || 0}</strong>
                </span>
              </div>
            </div>

            <table
              id="table_DL"
              className="table-s"
              style={{ display: "table" }}
            >
              <tbody>
                <tr>
                  <th style={styleHead} className="align-L sort_asc">
                    SM ID
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    MA ID
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    PL ID
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    Bet ID
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    Bet taken
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    Bet Settled
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    Event
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    Market
                  </th>
                  <th style={styleHead} className="align-C sort_asc">
                    Type
                  </th>
                  <th style={styleHead} className="sort_asc">
                    Odds req.
                  </th>
                  <th style={styleHead} className="sort_asc">
                    Stake
                  </th>
                  <th style={styleHead} className="sort_asc">
                    Profit/Loss
                  </th>
                  <th style={styleHead} className="sort_asc">
                    Status
                  </th>
                  <th style={styleHead} className="align-C sort_asc">
                    Remark
                  </th>
                  <th style={styleHead} className="align-L sort_asc">
                    IP Address
                  </th>
                </tr>

                {data?.data && data.data.length > 0 ? (
                  data.data.map((row, i) => (
                    <tr key={row?._id || i} className="table-rows">
                      <td style={styleBody} className="align-L">
                        N/A
                      </td>
                      <td style={styleBody} className="align-L">
                        N/A
                      </td>
                      <td style={styleBody} className="align-L">
                        {row?.clientName || "-"}
                      </td>
                      <td style={styleBody} className="align-L">
                        <a href="#">
                          {row?.casinoBetId ||
                            row?.matchBetId ||
                            row?.matchId ||
                            "-"}
                        </a>
                      </td>
                      <td style={styleBody} className="align-L">
                        <span className="small-date">
                          {formatDate(row?.createdAt)}
                        </span>
                      </td>
                      <td style={styleBody} className="align-L">
                        <span className="small-date">
                          {formatDate(row?.updatedAt)}
                        </span>
                      </td>
                      <td style={styleBody} className="align-L">
                        {betCheckObj[item?.gameType]}{" "}
                        {item?.gameType === "3"
                          ? row?.casinoName
                          : row?.matchName}
                      </td>
                      <td style={styleBody} className="align-L">
                        {item?.betFaireType === "betfair" && row?.market}
                        {item?.betFaireType === "bookmaker" && "Book Maker"}
                        {item?.betFaireType === "sportBook" && row?.fancyName}
                        {item?.betFaireType === "fancy" && row?.fancyName}
                        {item?.betFaireType === "casino" && row?.casinoType}
                      </td>
                      <td style={styleBody} className="align-C">
                        <span
                          className={
                            row?.betType === "back" || row?.type === "Yes"
                              ? "yes"
                              : "no"
                          }
                        >
                          {startCase(
                            row?.betType || row?.type || row?.gameCode,
                          )}
                        </span>
                      </td>
                      <td style={styleBody}>
                        {item?.betFaireType === "fancy"
                          ? `${row?.betRun}/${row?.bhav}`
                          : toFixedWithoutRounding(row?.bhav) || "-"}
                      </td>
                      <td style={styleBody}>
                        {item?.betFaireType !== "casino"
                          ? row?.amount
                          : row?.betAmount}{" "}
                        <strong>(USD)</strong>
                      </td>
                      <ProfitLossCell
                        item={row}
                        filter={{
                          type: item?.gameType,
                          betType: item?.betFaireType,
                        }}
                        getBetType={item?.betFaireType}
                        styleBody={styleBody}
                      />
                      <td style={styleBody}>
                        <span className="small-date">Settled</span>
                      </td>
                      <td style={styleBody}></td>
                      <td style={styleBody} className="align-L">
                        {(row?.ipAddress &&
                          row.ipAddress.replace("::ffff:", "")) ||
                          "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={15}>
                      <span>You have no bets in this time period.</span>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {data?.data?.length > 0 && data?.totalDocs > 0 && (
            <Pagination pagination={data} onPageChange={handlePageChange} />
          )}
        </div>
      </div>
    </div>
  );
}
